import React from "react";
import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import Markdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import { ChevronLeft } from "react-bootstrap-icons";

// Data
import data from "../../../../data/posts.json";

// Components
import Magnetic from "../../../Common/Magnetic/Magnetic";
import Tag from "../../../Common/Tag/Tag";

// SCSS
import "./BlogPost.scss";

const BlogPost = ({ setHoveredElement, lang }) => {
  const { id } = useParams();
  const [content, setContent] = useState("");

  const currentPost = data.find((p) => p.id === Number(id));

  const recommendations = data
    .filter((p) => p.id !== id && p.lang === lang)
    .slice(0, 3);

  useEffect(() => {
    fetch(`/posts/${id}.md`)
      .then((res) => res.text())
      .then((text) => {
        const parts = text.split("---");
        const body =
          parts.length >= 3 ? parts.slice(2).join("---").trim() : text;
        setContent(body);
      })
      .catch((err) => console.error("파일 에러", err));
  }, [id]);

  return (
    <div className="BlogPost">
      <section className="Post">
        <div className="Post__Wrapper">
          {/* Button (Back) */}
          <Magnetic
            as="div"
            setHoveredElement={setHoveredElement}
            // onClick={() => setHoveredElement(null)}
            className="Post__Button"
          >
            <Link to="/blog" className="Post__Button-Back">
              <ChevronLeft />
            </Link>
          </Magnetic>

          {/* Header */}
          <div className="Post__Header">
            <span className="Post__Header-Date">{currentPost.date}</span>
            <h3 className="Post__Header-Title">{currentPost.title}</h3>
          </div>

          {/* Content */}
          <div className="Post__Content">
            <Markdown rehypePlugins={[rehypeRaw]}>{content}</Markdown>
          </div>

          {/* Footer */}
          <div className="Post__Footer">
            {/* Tags */}
            <div className="Post__Footer-Tags">
              {currentPost.tags?.map((tag, index) => (
                <Tag key={tag} text={tag} />
              ))}
            </div>

            {/* List */}
            <ul className="Post__Footer-List">
              {recommendations.map((post) => (
                <li key={post.id} className="Post__Footer-Item">
                  <Magnetic as="div" setHoveredElement={setHoveredElement}>
                    <Link to={`/blog/${post.id}`} className="FooterItem">
                      <div className="FooterItem__Thumbnail">
                        <img
                          src={post.thumbnail}
                          alt={post.title}
                          className="FooterItem__Thumbnail-Image"
                        />
                      </div>
                      <div className="FooterItem__Title">
                        <span className="FooterItem__Title-Text">
                          {post.title}
                        </span>
                      </div>
                    </Link>
                  </Magnetic>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BlogPost;
